const CampaignTypeEnum = Object.freeze({
    DONATION: 'donation',
    QURBAN_KAMBING: 'qurban_kambing',
    QURBAN_SAPI: 'qurban_sapi',
    QURBAN_PATUNGAN: 'qurban_patungan'
})

export default CampaignTypeEnum